<template>
    <div style="height: 100%;">
        <el-menu style="height: 100%;"
                 default-active="2"
                 background-color="#304156"
                 text-color="rgb(191, 203, 217)"
                 active-text-color="rgb(64, 158, 255)"
                 class="el-menu-vertical-demo"
                 :collapse="isCollapse"
                 @select="handleSelect"
        >
            <el-menu-item index="home/index">
                <i class="el-icon-house"></i>
                <span slot="title">首页</span>
            </el-menu-item>

            <el-submenu v-for="item in menuDataList" :index="item.path">
                <template slot="title">
                    <i :class="item.icon"></i>
                    <span>{{ item.title }}</span>
                </template>
                <el-menu-item v-for="child in item.children" :index="child.path">
                    <i :class="child.icon"></i>
                    {{ child.title }}
                </el-menu-item>
            </el-submenu>
        </el-menu>
    </div>
</template>
<script>
import {getLeftMenu} from "@/utils/SessionStorage";
import {getWindowHeight} from "@/utils/GetWindowUtil";
import Bus from "@/utils/Bus";

export default {
    name: "Left",
    created() {
        this.menuDataList = JSON.parse(getLeftMenu());
        this.windowHeight = getWindowHeight();
    },
    mounted() {
        Bus.$on('collapsed', content => {
            console.log(content);
            this.isCollapse = content;
        });
    },
    beforeDestory() {
        Bus.$off('collapsed');
    },
    data() {
        return {
            menuDataList: [],
            windowHeight: 0,
            isCollapse: false
        }
    },
    methods: {
        handleSelect(key, keyPath) {
            let jumpPath = "";
            for (let i = 0; i < keyPath.length; i++) {
                jumpPath += "/" + keyPath[i];
            }
            this.$router.push(jumpPath);
        },
    }
}
</script>
